import React from 'react';
import './PayfazzPagination.css';

class PayfazzPagination extends React.Component {

  render() {
    const { currentPage, totalPage, handlePagePrev, handlePageNext } = this.props;
    if ( !currentPage || !totalPage || totalPage === 1){
      return (<div></div>);
    }
    return (
      <ul className='pagination'>
        <li>
          {currentPage === 1 || !totalPage ? (
            <button type='button' className='pagination__btn' disabled='true'>Prev</button>
          ) : (
            <button type='button' className='pagination__btn' onClick={handlePagePrev}>Prev</button>
          )}
        </li>
        <li className='pagination__number'><span>Page {currentPage} of {totalPage}</span></li>
        <li>
          { currentPage === totalPage ? (
            <button type='button' className='pagination__btn' disabled='true'>Next</button>
          ) : (
            <button type='button' className='pagination__btn' onClick={handlePageNext}>Next</button>
          )}
        </li>
      </ul>
    );
  }
}

export default PayfazzPagination;



// WEBPACK FOOTER //
// ./src/app/module/PayfazzPagination.js